import React from 'react';
import './FederalIncomeTaxWithholdingWarning.scss';
import Button from '../Button/Button';
import {
  FEDERAL_INCOME_TAX_WARNING,
  closeModal,
} from 'src/redux/modules/modals/modals.module';
import { useDispatch } from 'react-redux';

const FederalIncomeTaxWithholdingWarning = () => {
  const dispatch = useDispatch();
  return (
    <div className="federal-withholding-warning-container">
      <h1 className="federal-withholding-warning-heading">
        {' '}
        Important Information
      </h1>

      <div className="federal-withholding-warning-item">
        Please be aware that your transaction could result in a negative
        redemption value if the total of federal and state income tax
        withholding elections exceeds your requested amount.
      </div>

      <div className="federal-witholding-warning-base">
        <div></div>
        <Button
          buttonType="primary-large"
          className="federal-withholding-warning-ok-button btn-trp-primary-large e2e-ira-withholding-warning-ok-button"
          onClick={() => dispatch(closeModal(FEDERAL_INCOME_TAX_WARNING))}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default FederalIncomeTaxWithholdingWarning;
